import React from 'react'
import {BrowserRouter as Router} from 'react-router-dom'
import About_me from './components/About_me'
import Contact_me from './components/Contact_me'
import Home from './components/Home'
import MobileNav from './components/MobileNav'
import My_works from './components/My_works'
import Nav from './components/Nav'
import {makeStyles} from '@material-ui/core'
import Footer from './components/Footer'
const useStyles = makeStyles((theme)=>({
nav:{
  width:'228px',
  [theme.breakpoints.down('md')]:{
    width: '0'
  }
},
other_comp:{
  backgroundColor:  '#F4F4F7',
  paddingLeft:' 140px',
  paddingRight:'70px',
  [theme.breakpoints.down('md')]:{
    paddingLeft:' 100px',
 
  },
  [theme.breakpoints.down('sm')]:{
    paddingLeft:' 25px',
  paddingRight:'25px',
  }
},
hamMenu:{

}
}));
function App() {
  const classes= useStyles();
  return (
    <Router>

 
    <div style={{display:'flex'}}>
      <div className={classes.nav}>
      <Nav />
      <MobileNav/>
      </div>
   
      <div className={classes.other_comp} style={{}}>
      <Home/>
      <About_me/>
       <My_works/> 
      <Contact_me/>
      <Footer/>
      </div>
    
    </div>
    </Router>
  )
}

export default App
